import { render } from "./Administration.vue?vue&type=template&id=78620b0b"
import script from "./Administration.vue?vue&type=script&lang=js"
export * from "./Administration.vue?vue&type=script&lang=js"
script.render = render

export default script